import { isPresent } from 'ts-is-present'

import { entries } from ':/_lib/object.ts'

/**
 * @param hash - Key/values to use in the query string.
 *
 * @example
 * ```
 * fromHashToQueryString({ SearchQuery: 'Hello', pageSize: '3' }) → 'SearchQuery=Hello&pageSize=3'
 * ```
 */
const fromHashToQueryString = (hash: Record<string, string | number | null | undefined>) => {
  const params: string[][] = []

  for (const [key, value] of entries(hash)) {
    if (isPresent(value)) {
      params.push([key, String(value)])
    }
  }

  return new URLSearchParams(params).toString()
}

export default fromHashToQueryString
